import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {PATHS} from 'Routes';
import {OAUTH_PROVIDER} from '@guestapp/sdk';
import {useReservation} from 'context/reservation';
import {usePath} from 'hooks';
import {useGoogleSignIn} from 'hooks/auth/useGoogleSignIn';
import {CustomIcon} from '@guestapp/ui';
import {ContinueWithoutLoginButton, SocialAuthButton, SocialButtons} from '../styled';
const BASE_API_URL = import.meta.env.VITE_APP_BASE_URL;

type Props = {
  onSuccessAuth?: () => void;
  continueWithoutLogin?: boolean;
};
export const SocialLoginButtons = ({
  onSuccessAuth,
  continueWithoutLogin = true,
}: Props) => {
  const {t} = useTranslation();
  const {getFullPath} = usePath();
  const {allowEditingGuestNumber} = useReservation();
  const {subscribeOAuthGoogleCompletion} = useGoogleSignIn();

  const getContinueWithoutLoginPath = () => {
    const nextPath = allowEditingGuestNumber
      ? PATHS.onboarding.numberOfGuests
      : PATHS.home;

    return getFullPath(nextPath);
  };

  const handleClick = (provider: OAUTH_PROVIDER) => () => {
    window.open(
      `${BASE_API_URL}/api/v1/guest-accounts/oauth/${provider}`,
      '_blank',
      'noopener',
    );
  };

  useEffect(() => {
    const subscriber = subscribeOAuthGoogleCompletion({onSuccess: onSuccessAuth});

    return subscriber.unsubscribe;
  }, [onSuccessAuth, subscribeOAuthGoogleCompletion]);

  return (
    <SocialButtons>
      <SocialAuthButton
        label={t('auth.continue_with_google')}
        outlined
        onClick={handleClick(OAUTH_PROVIDER.google)}
        type="button"
        iconProps={{position: 'left'}}
        position="center"
        customIcon={<CustomIcon name="google" size={16} />}
      />
      {/*<SocialAuthButton*/}
      {/*  label={t('auth.continue_with_apple')}*/}
      {/*  outlined*/}
      {/*  onClick={handleClick(OAUTH_PROVIDER.apple)}*/}
      {/*  type="button"*/}
      {/*  position="center"*/}
      {/*  iconProps={{position: 'left'}}*/}
      {/*  customIcon={<CustomIcon name="apple" size={16} />}*/}
      {/*/>*/}
      {continueWithoutLogin && (
        <ContinueWithoutLoginButton
          link
          to={getContinueWithoutLoginPath()}
          label={t('auth.continue_without_logging_in')}
          type="button"
          iconProps={{position: 'left'}}
          position="center"
          customIcon={<CustomIcon name="no-login" size={24} />}
        />
      )}
    </SocialButtons>
  );
};
